import isURL from 'validator/es/lib/isURL';
import slugify from 'slugify';

function slug(str) {
  return slugify(str, {
    // backwards compatibility to Trott/node-slug (https://github.com/Trott/node-slug/blob/80485986a2d9ba234754932ad0bdeb5d8c1e3ac7/slug.js#L60)
    // note that period is removed as well: https://github.com/Trott/node-slug/blob/80485986a2d9ba234754932ad0bdeb5d8c1e3ac7/slug.js#L185
    remove: /[^\w\s\-_~]/g,
  });
}

export const isUrlValid = (url) => typeof url === 'string' && (url === '' || isURL(url));

export const addHttpToUrl = (url) => (/^https:\/\/|^http:\/\//i.test(url) ? url : `http://${url}`);

export const addProtocol = (url) => {
  if (!url || url.match(/:\/\//)) return url || '';
  return `https://${url}`;
};

export const isValidVideoURL = (url) => {
  // - Supported YouTube URL formats:
  //   - https://www.youtube.com/watch?v=QImCld9YubE
  //   - https://youtu.be/QImCld9YubE
  //   - https://youtube.googleapis.com/v/QImCld9YubE
  // - Supported Vimeo URL formats:
  //   - https://vimeo.com/83231771
  //   - https://player.vimeo.com/video/83231771

  if (typeof url !== 'string') {
    return false;
  }

  /* eslint-disable*/
  url.match(
    /^(http:\/\/|https:\/\/)?(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
  );
  /* eslint-enable */
  return RegExp.$3.includes('youtu') || RegExp.$3.includes('vimeo');
};

export function asPathFragment(str) {
  if (!str) return '';
  return `/${slug(str.toLowerCase())}`;
}

export function createCaminoCollegeProfilePath(hiid, name, state, extraPath, hash) {
  let url = `${process.env.CAMINO_BASE_URL}/colleges${asPathFragment(state || '')}${asPathFragment(
    name || '',
  )}/${hiid}`;

  if (extraPath) {
    url = `${url}/${extraPath}`;
  }

  if (hash) {
    url = `${url}#${hash}`;
  }

  return url;
}

export default isUrlValid;
